import { cn } from "@/lib/utils";
import { SPEC_BY_ID } from "@/lib/classes";

interface Props {
  specID: number;
  size?: number;
  className?: string;
}

export function SpecIcon({ specID, size = 28, className }: Props) {
  const entry = SPEC_BY_ID[specID];
  if (!entry) {
    return (
      <span
        className={cn("inline-block rounded-xs bg-surface-2", className)}
        style={{ width: size, height: size }}
      />
    );
  }
  const { spec, classDef } = entry;
  const url = `/icons/${spec.iconName.toLowerCase()}.png`;
  return (
    <span
      className={cn("inline-block shrink-0 overflow-hidden rounded-xs", className)}
      style={{
        width: size,
        height: size,
        outline: `1px solid color-mix(in srgb, var(--color-class-${classDef.token}) 60%, transparent)`,
        outlineOffset: "-1px",
      }}
      aria-label={`${spec.name} ${classDef.name}`}
      title={`${spec.name} ${classDef.name}`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={url} alt="" width={size} height={size} className="block h-full w-full" loading="lazy" />
    </span>
  );
}
